import ajaxServices from "./ajaxServices";
import microServices from "./microServices";

const getPaymentOptionsData = () => {
  return ajaxServices.httpGet(
    "drupalBaseUrl",
    "_format=json",
    "api",
    "paymentOptionsData"
  );
};

const getPaymentIntent = (orderId, redirectUrl) => {
  return microServices.get(
    "api",
    "paymentStoredCardsData",
    {
      headers: { "x-api-channel": "ONLINE" },
    },
    true,
    null,
    `?orderId=${orderId}&completeUrl=${redirectUrl}&failureUrl=${redirectUrl}`
  );
};

const removeStoredCard = (cardToken, type = "bankCard") => {
  return microServices.del(
    "api",
    "deleteStoredCard",
    {
      headers: { "x-api-channel": "ONLINE" },
    },
    true,
    [cardToken],
    `?type=${type}`
  );
};

const getMiniAppPaymentUrl = (orderId, authCode) => {

  return microServices.post(
    "api",
    "getMiniAppPaymentUrl",
    {
      orderId,
      authCode
    },
    {
      headers: { "x-api-channel": "SALES_MINI_APP" },
    },
    false
  );
};

export default {
  getPaymentOptionsData,
  getPaymentIntent,
  removeStoredCard,
  getMiniAppPaymentUrl,
};
